import { Injectable } from "@angular/core";
import { ISavedContactModel } from "../models/saved-contact/saved-contact.model";

@Injectable({
    providedIn: 'root'
  })
export class ContactUtilities {
    constructor() {
    }
    public isSavedContactComplete = (c: ISavedContactModel): boolean => {

        if(c == undefined){
            return false;
        }
    
        if(c.emailAddress === undefined || c.emailAddress === null || c.emailAddress === ''){
            return false;
        }
        if((c.telephoneNumber === undefined || c.telephoneNumber === null || c.telephoneNumber === '') && (c.mobileNumber === undefined || c.mobileNumber === null || c.mobileNumber === '')){
            return false;
        }
    
        return true
    }
}